/* unplugin-vue-components disabled */import { render } from "./SolutionData.vue?vue&type=template&id=5e22a01a"
import script from "./SolutionData.vue?vue&type=script&lang=js"
export * from "./SolutionData.vue?vue&type=script&lang=js"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__